function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_87",
  "data-name": "Path 87",
  d: "M0,0H16V16H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_319",
  "data-name": "Group 319",
  transform: "translate(-1445.94 -640.629)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_321",
  "data-name": "Group 321"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_320",
  "data-name": "Group 320"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_161",
  "data-name": "Path 161",
  d: "M1459.71,647.14a1.979,1.979,0,0,0-1.38-1.3,5.347,5.347,0,0,0-2.75-2.03,1.99,1.99,0,0,0-1.64-.86,1.958,1.958,0,0,0-1.63.86,5.372,5.372,0,0,0-2.76,2.03,1.988,1.988,0,0,0-.98,3.24,5.3,5.3,0,0,0,1.01,2.97,1.985,1.985,0,0,0,.79,1.88,1.964,1.964,0,0,0,2.08.15,5.314,5.314,0,0,0,1.49.21,5.588,5.588,0,0,0,1.49-.2,1.987,1.987,0,0,0,2.08-.16,2.014,2.014,0,0,0,.8-1.88,5.369,5.369,0,0,0,1-2.97A1.988,1.988,0,0,0,1459.71,647.14Zm-10.02,1.73a.821.821,0,0,1-.19-.09,1.166,1.166,0,0,1-.56-1.38,1.2,1.2,0,0,1,1.22-.81,1.374,1.374,0,0,1,.26.06,1.162,1.162,0,0,1,.75,1.47A1.177,1.177,0,0,1,1449.69,648.87Zm2.79,4.14a.555.555,0,0,1-.07.09,1.165,1.165,0,0,1-1.89-1.34c.02-.04.05-.08.07-.12a1.178,1.178,0,0,1,1.64-.26A1.166,1.166,0,0,1,1452.48,653.01Zm1.46-2.91a1.17,1.17,0,1,1,1.17-1.17A1.171,1.171,0,0,1,1453.94,650.1Zm0-4a1.171,1.171,0,0,1-1.17-1.17,1.118,1.118,0,0,1,.05-.31,1.161,1.161,0,0,1,1.12-.86,1.182,1.182,0,0,1,1.13.86,1.1,1.1,0,0,1,.04.31A1.165,1.165,0,0,1,1453.94,646.1Zm3.09,7.17a1.159,1.159,0,0,1-1.56-.17.548.548,0,0,1-.07-.09,1.167,1.167,0,1,1,1.89-1.37c.03.04.05.08.08.12A1.174,1.174,0,0,1,1457.03,653.27Zm1.35-4.49a.664.664,0,0,1-.19.09,1.166,1.166,0,0,1-1.47-.75,1.154,1.154,0,0,1,.75-1.47,1.093,1.093,0,0,1,.26-.06,1.175,1.175,0,0,1,1.21.81A1.154,1.154,0,0,1,1458.38,648.78Z",
  fill: "#4d4d4d"
}))));

function SvgFenderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "more_vert-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFenderIcon);
export default __webpack_public_path__ + "static/media/fenderIcon.3738b75d.svg";
export { ForwardRef as ReactComponent };